import React from "react";
import { Star } from "lucide-react";

const ownerTestimonials = [
  { name: "Avery Cole", role: "Agency Owner", agency: "Northline Digital", quote: "HireX8 helped us ship 3 full client campaigns in the same month without adding internal headcount." },
  { name: "Jordan Blake", role: "Founder & CEO", agency: "Signal Foundry", quote: "Our turnaround time dropped from 12 days to 4 days and our clients immediately noticed the speed." },
  { name: "Riley Chen", role: "Co-Founder", agency: "Lighthouse Creative", quote: "We finally scaled web, SEO, and content delivery together and our retention rate climbed this quarter." },
  { name: "Morgan Price", role: "Managing Partner", agency: "Vista Growth Lab", quote: "The quality feels senior-level and consistent, even on fast-moving multi-channel projects." },
  { name: "Taylor Singh", role: "Agency Principal", agency: "Peakframe Studio", quote: "We used HireX8 to handle overflow and ended up increasing monthly project capacity by 40%." },
  { name: "Casey Morales", role: "Owner & Creative Director", agency: "Atlas Pixel Co.", quote: "Our team now focuses on strategy while execution gets done quickly and cleanly in the background." },
  { name: "Parker Reed", role: "Founder", agency: "Monarch Digital Works", quote: "We accepted bigger contracts because we trusted delivery support would keep pace with demand." },
  { name: "Quinn Patel", role: "CEO", agency: "Scale Avenue Agency", quote: "The AI-accelerated workflows gave us real margin improvement without lowering quality." },
  { name: "Reese Turner", role: "Owner", agency: "Orbit Click Media", quote: "Client satisfaction jumped after we started delivering milestones ahead of schedule." },
  { name: "Blake Austin", role: "Founder & Agency Lead", agency: "Brightlake Interactive", quote: "We moved from constantly firefighting to confidently planning because execution became predictable." },
  { name: "Dakota Ellis", role: "Principal Consultant & Owner", agency: "Matterlane Digital", quote: "HireX8 feels like adding a trained extension of our agency, not another vendor to manage." },
  { name: "Skyler Hayes", role: "Co-Owner", agency: "Proofline Studio", quote: "We launched two net-new service lines this year because we finally had enough production bandwidth." },
  { name: "Logan Ford", role: "Founder & Managing Director", agency: "Corecraft Marketing", quote: "The response speed and communication quality have been strong from kickoff through final delivery." },
  { name: "Emerson Vale", role: "Agency Owner & Strategist", agency: "Summit Orbit", quote: "Our account team reports fewer bottlenecks and fewer late-night revisions across active clients." },
  { name: "Rowan Bennett", role: "Founder, Boutique Agency", agency: "Nimble Harbor", quote: "The combination of human talent plus AI execution gives us output that feels both fast and thoughtful." },
  { name: "Hayden Brooks", role: "President & Owner", agency: "Rivergrid Digital", quote: "We boosted billable throughput while keeping our creative standards exactly where we wanted them." },
  { name: "Alex Monroe", role: "Agency Owner", agency: "Modern Ladder Media", quote: "The value is obvious: faster production cycles, better margins, and happier account teams." },
  { name: "Peyton Gray", role: "Founder & Operator", agency: "Kiteframe Digital", quote: "We no longer say no to timeline-sensitive work because we can scale up quickly and responsibly." },
  { name: "Jamie Flores", role: "Managing Owner", agency: "Launch Harbor Agency", quote: "Every engagement has felt organized, transparent, and immediately useful to our delivery pipeline." },
  { name: "Robin Keller", role: "Owner & Growth Lead", agency: "Catalyst Crew", quote: "HireX8 helped us maintain momentum during our busiest quarter without quality slipping." },
  { name: "Finley Dawson", role: "Founder & Creative Owner", agency: "Pioneer Pixel House", quote: "Our team now closes projects faster and has more room for strategic upsell conversations." },
];

const projectManagerTestimonials = [
  { name: "Mia Lawson", role: "Digital Project Manager", agency: "Northline Digital", quote: "Task handoffs became far cleaner, and we reduced delivery confusion across design, SEO, and dev." },
  { name: "Noah Rivera", role: "Senior Project Manager", agency: "Signal Foundry", quote: "Our sprint boards stay healthy now because blockers get resolved in hours instead of days." },
  { name: "Ethan Wells", role: "Client Delivery Manager", agency: "Lighthouse Creative", quote: "Clients love the pace and I love that deadlines are finally realistic even with changing scope." },
  { name: "Sofia Graham", role: "Web Project Manager", agency: "Vista Growth Lab", quote: "We shipped a complex web relaunch on time with fewer escalation calls than any recent project." },
  { name: "Levi Cooper", role: "Implementation Project Manager", agency: "Peakframe Studio", quote: "Coordination is smoother because their team communicates in a way PMs can act on quickly." },
  { name: "Harper Shaw", role: "Account Project Manager", agency: "Atlas Pixel Co.", quote: "Status meetings are shorter now since deliverables arrive complete and ready for review." },
  { name: "Isaac Palmer", role: "Campaign Project Manager", agency: "Monarch Digital Works", quote: "We hit multi-channel launch dates with less stress and fewer last-minute content bottlenecks." },
  { name: "Chloe Sutton", role: "Operations Project Manager", agency: "Scale Avenue Agency", quote: "Our utilization improved because we stopped overloading internal specialists with overflow work." },
  { name: "Gabriel Hunt", role: "Senior Delivery PM", agency: "Orbit Click Media", quote: "Escalations dropped because quality checks and revisions came back fast and consistently." },
  { name: "Lily Tran", role: "Program Project Manager", agency: "Brightlake Interactive", quote: "The throughput increase has been huge, but what impressed me most is reliability week after week." },
  { name: "Owen Scott", role: "Client Success Project Manager", agency: "Matterlane Digital", quote: "I can forecast delivery with confidence now, which has made client communication much easier." },
  { name: "Grace Kim", role: "Agile Project Manager", agency: "Proofline Studio", quote: "Their team adapts quickly when priorities shift, so we stay on track even during scope changes." },
  { name: "Aiden Brooks", role: "Technical Project Manager", agency: "Corecraft Marketing", quote: "Build quality and turnaround improved simultaneously, which is rare and incredibly valuable." },
  { name: "Natalie Ross", role: "Creative Project Manager", agency: "Summit Orbit", quote: "Review cycles are tighter now because first drafts arrive so much closer to brief expectations." },
  { name: "Lucas Foster", role: "Production Project Manager", agency: "Nimble Harbor", quote: "We finally stabilized our delivery cadence and reduced weekend catch-up work for the whole team." },
  { name: "Zoe Allen", role: "Portfolio Project Manager", agency: "Rivergrid Digital", quote: "Capacity planning is easier because we can scale support up or down based on active client load." },
  { name: "Caleb Ward", role: "Digital Delivery Project Manager", agency: "Modern Ladder Media", quote: "Communication is clear, response times are fast, and the delivered work is consistently useful." },
  { name: "Stella Price", role: "Strategic Project Manager", agency: "Kiteframe Digital", quote: "Our launches feel controlled again, even when multiple clients are going live in the same week." },
  { name: "Mason Diaz", role: "PMO Lead", agency: "Launch Harbor Agency", quote: "This has been one of the easiest external teams to integrate into our existing delivery rhythm." },
  { name: "Aria Young", role: "Project Delivery Lead", agency: "Catalyst Crew", quote: "The support reduced backlog pressure and gave our core team breathing room to focus on priorities." },
  { name: "Julian Hart", role: "Senior Client Project Manager", agency: "Pioneer Pixel House", quote: "We increased output without chaos, and that is exactly what our agency needed this year." },
];

const messageFormats = ["imessage", "text", "whatsapp", "email", "review"];
const messageTimes = ["8:12 AM", "9:45 AM", "11:03 AM", "1:18 PM", "3:27 PM", "5:54 PM", "7:06 PM"];

const allTestimonials = [...ownerTestimonials, ...projectManagerTestimonials].map(
  (testimonial, index) => ({
    id: index + 1,
    format: messageFormats[index % messageFormats.length],
    time: messageTimes[index % messageTimes.length],
    ...testimonial,
  })
);

const StarRating = () => (
  <div className="flex items-center gap-1">
    {Array.from({ length: 5 }).map((_, idx) => (
      <Star key={idx} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

const IPhoneStyleCard = ({ testimonial }) => (
  <div className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
    <div className="flex items-center justify-between border-b border-slate-100 pb-3 text-[11px] text-slate-500">
      <span>Messages</span>
      <span>{testimonial.time}</span>
    </div>
    <div className="mt-3 space-y-2">
      <div className="max-w-[80%] rounded-2xl rounded-bl-md bg-slate-100 px-3 py-2 text-xs text-slate-600">
        How has delivery been?
      </div>
      <div className="ml-auto max-w-[88%] rounded-2xl rounded-br-md bg-[#0a84ff] px-3 py-2 text-xs text-white">
        "{testimonial.quote}"
      </div>
    </div>
    <div className="mt-4 flex items-center justify-between text-[11px] text-slate-500">
      <StarRating />
      <span>{testimonial.role}</span>
    </div>
  </div>
);

const TextMessageCard = ({ testimonial }) => (
  <div className="rounded-3xl border border-emerald-200 bg-white p-4 shadow-sm">
    <div className="flex items-center justify-between border-b border-emerald-100 pb-3 text-[11px] text-emerald-700">
      <span>Text Message</span>
      <span>{testimonial.time}</span>
    </div>
    <div className="mt-3">
      <div className="max-w-[90%] rounded-2xl rounded-tl-md bg-emerald-100 px-3 py-2 text-xs text-emerald-900">
        "{testimonial.quote}"
      </div>
    </div>
    <div className="mt-4 flex items-center justify-between text-[11px] text-emerald-700">
      <StarRating />
      <span>{testimonial.role}</span>
    </div>
  </div>
);

const WhatsAppCard = ({ testimonial }) => (
  <div className="rounded-3xl border border-green-200 bg-[#e9f8ed] p-4 shadow-sm">
    <div className="flex items-center justify-between border-b border-green-200 pb-3 text-[11px] text-green-900">
      <span>WhatsApp</span>
      <span>{testimonial.time}</span>
    </div>
    <div className="mt-3 flex justify-end">
      <div className="max-w-[88%] rounded-2xl rounded-br-md bg-[#d2f8c6] px-3 py-2 text-xs text-green-950">
        "{testimonial.quote}"
      </div>
    </div>
    <div className="mt-4 flex items-center justify-between text-[11px] text-green-900">
      <StarRating />
      <span>{testimonial.role}</span>
    </div>
  </div>
);

const EmailCard = ({ testimonial }) => (
  <div className="rounded-3xl border border-sky-200 bg-white p-4 shadow-sm">
    <div className="rounded-2xl border border-sky-100 bg-sky-50 p-3 text-xs text-sky-900">
      <div><strong>From:</strong> {testimonial.name}</div>
      <div><strong>Role:</strong> {testimonial.role}</div>
      <div><strong>Subject:</strong> 5-star delivery feedback</div>
    </div>
    <p className="mt-3 text-xs leading-relaxed text-slate-700">"{testimonial.quote}"</p>
    <div className="mt-4 flex items-center justify-between text-[11px] text-sky-800">
      <StarRating />
      <span>{testimonial.time}</span>
    </div>
  </div>
);

const ReviewPostCard = ({ testimonial }) => (
  <div className="rounded-3xl border border-orange-200 bg-white p-4 shadow-sm">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm font-semibold text-slate-900">{testimonial.name}</p>
        <p className="text-[11px] text-slate-500">{testimonial.role}</p>
      </div>
      <span className="rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-semibold text-orange-700">
        Verified Review
      </span>
    </div>
    <div className="mt-3"><StarRating /></div>
    <p className="mt-3 text-xs leading-relaxed text-slate-700">"{testimonial.quote}"</p>
    <p className="mt-3 text-[11px] text-slate-500">{testimonial.agency}</p>
  </div>
);

const formatCardByType = (testimonial) => {
  if (testimonial.format === "imessage") return <IPhoneStyleCard testimonial={testimonial} />;
  if (testimonial.format === "text") return <TextMessageCard testimonial={testimonial} />;
  if (testimonial.format === "whatsapp") return <WhatsAppCard testimonial={testimonial} />;
  if (testimonial.format === "email") return <EmailCard testimonial={testimonial} />;
  return <ReviewPostCard testimonial={testimonial} />;
};

const FiveStarTestimonials = ({ flat = false }) => {
  return (
    <section className="relative overflow-hidden py-24" style={{ background: '#0c0b09', borderTop: '1px solid rgba(240,236,228,0.05)' }}>
      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <div className="mb-12 text-center">
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
            <span style={{ width: 5, height: 5, background: '#e8701a', display: 'inline-block', transform: 'rotate(45deg)', animation: 'hx8-glow 2s ease-in-out infinite' }} />
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#e8701a' }}>5-Star Testimonials</span>
          </div>
          <h2 className="mx-auto max-w-4xl text-4xl font-bold leading-tight lg:text-5xl" style={{ color: '#f0ece4', letterSpacing: '-0.035em', fontFamily: "'Space Grotesk', sans-serif" }}>
            42 Real 5-Star Reviews From Digital Agency Owners & Project Managers
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-base lg:text-lg" style={{ color: 'rgba(240,236,228,0.45)' }}>
            Presented in chat, text, WhatsApp-style, email, and review-post layouts to mirror
            the way agencies actually share feedback.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
          {allTestimonials.map((testimonial) => (
            <article key={testimonial.id} className="h-full">
              <div className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">
                {testimonial.agency}
              </div>
              {formatCardByType(testimonial)}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FiveStarTestimonials;
